import React, { useEffect, useRef } from 'react';

type ColabCheckboxProps = {
  id: string;
  label?: string;
  value?: string;
  checked: boolean;
  onChange: (event: React.FormEvent<HTMLInputElement>) => void;
  ariaLabel?: string;
  description?: string;
  disabled?: boolean;
  extraClasses?: string;
  indeterminate?: boolean;
  name?: string;
};

function ColabCheckbox({
  id,
  label,
  value,
  checked,
  onChange,
  ariaLabel,
  description,
  disabled = false,
  extraClasses = '',
  indeterminate = false,
  name,
}: ColabCheckboxProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const descriptionId = description ? `${id}-description` : undefined;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <label className={`colab-checkbox ${disabled ? 'colab-checkbox--disabled' : ''} ${extraClasses}`} htmlFor={id}>
      <span className="colab-checkbox__control">
        <input
          ref={inputRef}
          id={id}
          name={name}
          type="checkbox"
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          aria-label={label ? undefined : ariaLabel}
          aria-describedby={descriptionId}
          aria-checked={indeterminate ? 'mixed' : checked}
          className="colab-checkbox__input"
        />
        <span className={`colab-checkbox__box ${indeterminate ? 'colab-checkbox__box--indeterminate' : ''}`}>
          <svg fill="none" viewBox="0 0 14 14" aria-hidden="true" className="colab-checkbox__icon">
            <path
              d="M3 8L6 11L11 3.5"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="colab-checkbox__check"
            />
            <path
              d="M3 7H11"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="colab-checkbox__dash"
            />
          </svg>
        </span>
      </span>
      {label && (
        <span className="colab-checkbox__text">
          <span className="colab-checkbox__label">{label}</span>
          {description && (
            <span id={descriptionId} className="colab-checkbox__description">
              {description}
            </span>
          )}
        </span>
      )}
    </label>
  );
}

export default ColabCheckbox;
